<template>
  <main-layout>
    <template slot="header-title">{{ $t('events.title') }}</template>

    <template slot="header-actions">
      <common-button
        @click="eventCreation = true">Create an event</common-button>
    </template>

    <template slot="main">
      <div
        v-if="loading" v-loading="loading"
        class="container mx-auto" />
      <div
        v-else-if="events.length > 0"
        class="container mx-auto">
        <ul class="event-table-list">
          <div class="bg-white rounded mb-5 shadow rounded">
            <li class="header">
              <div>
                <el-tooltip effect="dark" content="The alias identifies an action. It's used to trigger an event by API or to build statistics. The alias identifies when/what action is triggered e.g.: user connection, alias could be CONNECT"
                            placement="top"><span>alias</span></el-tooltip>
              </div>
              <div>
                <el-tooltip effect="dark" content="This will build the message in the user activity. E.g. 'is the leader of the week' will result in: 'Paul is the leader of the week' being displayed in the 'activity' widget." placement="top"><span>{{ $t('events.sentence-action') }}</span></el-tooltip>
              </div>
              <div>
                <el-tooltip effect="dark" content="Points earned by the user per action." placement="top"><span>score</span></el-tooltip>
              </div>
              <div>
                <el-tooltip effect="dark" content="'Public', this action is visible to everybody in the activity feed. 'Private' only the user will see the action. 'Hidden' the action is not displayed (but could trigger an achivement)" placement="top"><span>visibility</span></el-tooltip>
              </div>
              <div>
                <el-tooltip effect="dark" content="How many times the action can be done in a limited time. e.g. 1 per day" placement="top"><span>limitation</span></el-tooltip>
              </div>
              <div>
                <el-tooltip effect="dark" content="Number of badges linked to the event." placement="top"><span>badge linked</span></el-tooltip>
              </div>
              <div></div>
            </li>
            <li>
              <div class="research-bar">
                <el-input placeholder="Filter events" v-model="search" class="input-with-select">
                  <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
              </div>
            </li>
          </div>
          <event v-for="event in sortedEvents" :key="event.list" :id="event.id"></event>
        </ul>
      </div>
      <empty v-show="sortedEvents.length === 0" :title="$t('event.empty.title')" :message="$t('event.empty.message')">
        <a @click="eventCreation = true">{{ $t('event.actions.create') }}</a>
      </empty>
      <event-form v-if="eventCreation" @close="closeEventCreation"></event-form>
    </template>
  </main-layout>
</template>

<script>
import Event from '@/components/events/event.vue'
import EventForm from '@/components/events/event-form.vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import Empty from '@/components/box-entity-empty.vue'

export default {
  components: { EventForm, Event, Empty },
  data () {
    return {
      eventCreation: false,
      loading: true,
      search: ''
    }
  },
  computed: {
    ...mapState('events', {
      events: 'items'
    }),
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    sortedEvents () {
      let events = this.events.slice().sort((a, b) => a.alias > b.alias)

      events = events.filter(event => {
        return event.alias.toLowerCase().includes(this.search.toLowerCase())
      })

      return events
    }
  },
  watch: {
    site: function (site) {
      this.initEventsList()
    }
  },
  methods: {
    ...mapActions('events', ['loadEvents']),

    initEventsList () {
      if (this.site) {
        this.loadEvents(this.site.sitekey)
          .then((result) => {
            this.isEventsLoaded = true
          })
          .catch((result) => {
            setTimeout(() => {
              this.isEventsLoaded = true
            }, 1000)
          })
          .then(() => {
            setTimeout(() => {
              this.loading = false
            }, 1000)
          })
      }
    },
    closeEventCreation (event) {
      this.eventCreation = false
      if (event && event.id) {
        this.scrollToEvent(event)
      }
    },

    scrollToEvent (event) {
      let element = document.getElementById('event-' + event.id)
      this.$SmoothScroll(element, 800)
      element.style.background = '#1B9CFC'
      element.style.color = '#fff'
      setTimeout(() => {
        element.style.color = 'inherit'
        element.style.background = 'inherit'
      }, 2000)
    }

  },
  mounted () {
    this.initEventsList()
  }
}
</script>

<style lang="scss" scoped>

.event-list {
    min-height: 120px;
    width: 100%;
}
.event-table-list {
    margin:0;
    width: 100%;
    li {
        transition: all 1500ms ease-in-out;
        font-size: 15px;
        font-weight: 400;
        list-style: none;
        width: 100%;
        display: grid;
        grid-template-columns: 3fr 3fr 1fr 1fr 1fr 1fr 60px;
        justify-items: center;
        align-items: center;
        border-bottom:1px solid #ededed;
        padding: 0 12px;
        .group-actions .trigger {
            padding: 10px;
        }
        &.header {
            position: sticky;
            top: 0;
            background: #fff;
            font-weight: 600;
            div {
                text-transform: capitalize;
            }
        }
        > div {
            padding: 8px;
        }
    }
}

.events.loading {
    height: 120px;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Event/EventList.vue